module.exports = __webpack_public_path__ + "img/investigation.e1d4b7f9.svg";